(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gingerkite-offer-referral"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gk-offer-referral')) {
    customElements.define('gk-offer-referral', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        const refresh = () => this.refresh();
        document.addEventListener('visitorConsentCollected', refresh, options);
        window.addEventListener('pageshow', refresh, options);
        this.form.addEventListener('change', refresh, options);
        this.form.addEventListener('click', refresh, { ...options, capture:true });
        this.form.addEventListener('formdata', event => {
          this.refresh(String(event.formData.get('id') || ''));
          for (const key of this.keys()) event.formData.delete('properties[' + key + ']');
          for (const input of this.querySelectorAll('input')) event.formData.set(input.name, input.value);
        }, options);
        if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.2' }], error => {
            if (!error && this.controller) refresh();
          });
        }
        refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.expiryTimer);
      }
      keys() {
        return ['_gk_offer_id','_gk_offer_role','_gk_offer_version','_gk_offer_placement',
          '_gk_presentation_id','_gk_offer_action','_gk_clicked_at','_gk_internal_test'];
      }
      read(variant) {
        try {
          const privacy = window.Shopify?.customerPrivacy;
          if (window.Shopify?.designMode || privacy?.analyticsProcessingAllowed?.() !== true) {
            if (privacy) sessionStorage.removeItem('gk_offer_referral');
            return null;
          }
          const context = JSON.parse(sessionStorage.getItem('gk_offer_referral') || 'null');
          if (!context) return null;
          const p = context.properties;
          const now = Date.now();
          if (!Number.isFinite(context.expires) || context.expires <= now || context.expires > now + 1800000 ||
              !p || p._gk_offer_action !== 'view_details' || !['add_on','downsell'].includes(p._gk_offer_role) ||
              !/^[0-9a-f-]{36}$/i.test(p._gk_presentation_id || '') ||
              !['0','1'].includes(p._gk_internal_test) ||
              this.keys().some(key => typeof p[key] !== 'string' || p[key].length > 100)) {
            sessionStorage.removeItem('gk_offer_referral');
            return null;
          }
          if (p._gk_offer_id !== variant) return null;
          return context;
        } catch {
          return null;
        }
      }
      refresh(variant) {
        this.replaceChildren();
        clearTimeout(this.expiryTimer);
        const id = typeof variant === 'string' ? variant : this.form.querySelector('[name="id"]')?.value;
        const context = this.read(id);
        if (!context) return;
        for (const key of this.keys()) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + key + ']';
          input.value = context.properties[key];
          this.append(input);
        }
        this.expiryTimer = setTimeout(() => this.refresh(), context.expires - Date.now());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
